import { render, staticRenderFns } from "./TournamentWrapperPage.vue?vue&type=template&id=0327bf03&scoped=true&"
import script from "./TournamentWrapperPage.vue?vue&type=script&lang=js&"
export * from "./TournamentWrapperPage.vue?vue&type=script&lang=js&"
import style0 from "./TournamentWrapperPage.vue?vue&type=style&index=0&id=0327bf03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0327bf03",
  null
  
)

export default component.exports